// extracted by mini-css-extract-plugin
export default {"root":"_2LF7X","normal":"_2Mjsc","tier-link":"M1pXQ","tierLink":"M1pXQ"};